export default __webpack_public_path__ + "static/media/celebrate.56214e744fb943047d4b76d72edf6df7.svg";